import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import SpeedIcon from '@mui/icons-material/Speed';

import { MeterTypeLabel } from '#apps/client-web/features/audit-form-background/constants';
import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

export type MetersDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const MetersDetails = ({ control }: MetersDetailsProps) => {
  const { errors } = useFormState({
    control,
  });

  const { general: { meters } = {} } = useWatch({
    control,
  });

  const count = meters?.length ?? 0;
  const hasError = !!errors.general?.meters;

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <SpeedIcon fontSize="inherit" />
            <span>&nbsp;Meters</span>
          </Grid>
        </Typography>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Count:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              hasError ? 'error' : count === 0 ? 'textDisabled' : 'textPrimary'
            }>
            {count === 0
              ? 'No meters added'
              : `${count} meter${count !== 1 ? 's' : ''}`}
          </Typography>
        </Grid>
        {count > 0 && (
          <Grid container justifyContent="space-between">
            <Typography component="span" variant="body2">
              Types:
            </Typography>
            <Typography component="span" variant="body2" color="textPrimary">
              {[...new Set(meters?.map((m) => MeterTypeLabel[m.type!]))].join(
                ', ',
              )}
            </Typography>
          </Grid>
        )}
        <Divider />
      </Stack>
    </Box>
  );
};
